<template>
  <transition appear name="fade">
    <div class="v-warning__wrapper">
      <div class="v-warning__icon">
        <img :src="icon" alt="warningImage" />
      </div>
      <div class="v-warning__message">
        {{ message }}
      </div>
      <div class="v-warning__illustration">
        <img :src="illustration" alt="illustrationImage" />
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import warningIcon from "@/assets/images/warningIcon.svg";

export default Vue.component("VWarning", {
  props: {
    message: VueTypes.string,
    icon: VueTypes.string.def(warningIcon),
    illustration: VueTypes.string,
    timeout: VueTypes.number.def(2000)
  },

  methods: {
    warningDisappear() {
      if (this.timeout) {
        return setTimeout(() => ( this.$emit("change")), this.timeout);
      }
    }
  },

  mounted() {
    this.warningDisappear()

  }
});
</script>

<!--Styles had written according to illustration with shadows on all sides-->

<style lang="scss" scoped>
$ns: "v-warning";

.#{$ns}__wrapper {
  position: absolute;
  padding: 15px 15px 0;
  width: 270px;
  height: fit-content;
  max-height: 257px;
  background: #ffffff;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  font-family: Lato-Regular, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.61;
  text-align: center;

  z-index: 1;
}

.#{$ns}__message {
  margin-top: 10px;
}

.#{$ns}__icon {
  height: 45px;
}

.#{$ns}__illustration {
  height: 1;
}

/*For transition*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
